import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  header {
    text-align: center !important;
    line-height: 1.25;

    h1 {
      font-size: 1rem;
      color: var(--sl-fg-base);
    }

    p.subtitle {
      font-size: 0.875rem;
      color: var(--sl-fg-base-soft);
    }
  }

  .children {
    .selectWrapper,
    .searchWrapper {
      width: 330px;
      max-width: 100%;
    }
  }
`

export const Image = styled.div`
  margin: 2rem;
`
